import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api/api.service';
import { Observable } from 'rxjs';
import { ReleaseNote } from 'src/app/models/release-note';

@Injectable({
  providedIn: 'root',
})
export class ReleasesService {
  getReleases(): Observable<ReleaseNote[]> {
    return this.apiService.get<ReleaseNote[]>('/dashboard/release_note/getList');
  }

  saveReleaseNote(releaseNote: ReleaseNote): Observable<JSON> {
    return this.apiService.post<JSON>(`/dashboard/release_note/save`, releaseNote);
  }

  deleteReleaseNote(noteId: number): Observable<JSON> {
    return this.apiService.delete<JSON>(`/dashboard/release_note/delete/${noteId}`);
  }

  editReleaseNote(noteId: number, releaseNote: ReleaseNote): Observable<ReleaseNote> {
    return this.apiService.put<ReleaseNote>(`/dashboard/release_note/edit/${noteId}`, releaseNote);
  }

  constructor(private apiService: ApiService) {}
}
